module.exports = __webpack_public_path__ + "img/filter.f14ceb97.svg";